import { ProductCardProps } from '@teko/types/ecommerce';
import { LazyComponent } from 'components/LazyComponent';
import {
  AsComponentProps,
  SlotComponentProps,
} from 'modules/page-builder/types';
import React from 'react';
import { useActionButtons } from './useActionButtons';
import { useSearchProductDiscovery } from './useSearchProductDiscovery';

type InjectedProps = {
  productsLoading?: boolean;
  products?: ProductCardProps[];
  buyNow?: (product: ProductCardProps) => Promise<void>;
  addToCart?: (product: ProductCardProps) => Promise<void>;
};

type LazyVideoPreviewCarousel = SlotComponentProps<{
  products: ProductCardProps[];
}>;

type VideoPreviewCarouselSlotProps = LazyVideoPreviewCarousel &
  AsComponentProps<InjectedProps> & {
    skus?: string[];
  };

const VideoPreviewCarousel: React.FC<VideoPreviewCarouselSlotProps> = ({
  skus,
  serverData,
  as: Comp,
  asProps,
}: VideoPreviewCarouselSlotProps) => {
  const { addToCart, buyNow } = useActionButtons();
  const { products, loading } = useSearchProductDiscovery(
    skus?.length
      ? {
          filter: {
            skus,
          },
        }
      : {},
    serverData,
  );

  const injectedProps: InjectedProps = {
    productsLoading: loading,
    products,
    addToCart,
    buyNow,
  };

  if (!Comp) return null;

  return <Comp {...asProps} {...injectedProps} />;
};

export const LazyVideoPreviewCarousel: React.FC<LazyVideoPreviewCarousel> = (
  props,
) => {
  return (
    <LazyComponent>
      <VideoPreviewCarousel {...props} />
    </LazyComponent>
  );
};
